<template>
  <div class="pr-5">
    <v-row>
      <v-col cols="6"><h1 class="font-weight-thin">Service Area Categories</h1></v-col>
      <v-col cols="6" class="text-right"
        ><v-btn @click="showCreateForm()" class="my-3" data-cy="categoryList__createBtn" color="primary" outlined small>
          <v-icon class="mr-2" small>fas fa-plus</v-icon>Add New Category
        </v-btn></v-col
      >
    </v-row>
    <v-card>
      <v-card-text>
        <v-text-field
          v-model="search"
          prepend-inner-icon="search"
          label="Search..."
          single-line
          hide-details
          outlined
        ></v-text-field>
      </v-card-text>
      <v-data-table
        :headers="headerList"
        :hide-default-footer="true"
        :items="categoryList"
        :search="search"
        disable-pagination
      >
        <template v-slot:item="{ item }">
          <tr>
            <td data-cy="categoryList--item">{{ item.name }}</td>
            <td>
              <v-icon small @click="$router.push({ name: 'adminServiceAreaCategory', params: { id: item.id } })"
                >fas fa-edit</v-icon
              >
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
    <AdminServiceAreaCategoryCreate v-model="showForm"></AdminServiceAreaCategoryCreate>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import AdminServiceAreaCategoryCreate from "./AdminServiceAreaCategoryCreate";

export default {
  components: {
    AdminServiceAreaCategoryCreate,
  },
  computed: {
    ...mapState({
      categoryList: state => state.admin.serviceAreaCategory.list,
    }),
  },
  async created() {
    try {
      await this.fetchCategoryList();
    } catch (e) {
      console.error(e);
    }
  },
  data() {
    return {
      headerList: [
        {
          text: "Service Area Category",
          value: "name",
        },
        {
          sortable: false,
          value: "actions",
        },
      ],
      search: null,
      showForm: false,
    };
  },
  methods: {
    showCreateForm() {
      this.setEdit(Object.assign({}));
      this.showForm = true;
    },
    ...mapActions({
      fetchCategoryList: "admin/serviceAreaCategory/list",
    }),
    ...mapMutations({
      setEdit: "admin/serviceAreaCategory/setEdit",
    }),
  },
};
</script>
